import { DataSourceDetails } from "Hooks/Api/apiBusinessNumber";
import { dataTypeSourceIcons, dataTypeSourceOptions } from "Models/Enums/MappedEnumOptions";
import moment from "moment";

export type EntityItem = {
	status: string;
	type: string;
	entityName: string;
	source?: DataSourceDetails;
	fallbackValue?: string;
}

type EntityItemProps = {
	children: React.ReactNode
};

type EntitySubItemProps = {
	item: EntityItem;
}

export function EntityItemSection({
	children
}: EntityItemProps) {
	return (
		<>
			{children}
		</>
	)
}

EntityItemSection.Status = function EntityItemTitle({ item }: EntitySubItemProps) {
	const { status } = item;
	return (
		<span>
			<b>Status: </b>{status}
		</span>
	)
}

EntityItemSection.Type = function EntityItemType({ item }: EntitySubItemProps) {
	const { type } = item;
	return (
		<span>
			<b>Type: </b>{type}
		</span>
	)
}

EntityItemSection.EntityName = function EntityItemName({ item }: EntitySubItemProps) {
	const { entityName } = item;
	return (
		<span>
			<b>Entity Name: </b>{entityName}
		</span>
	)
}
EntityItemSection.Source = function EntityItemName({ item }: EntitySubItemProps) {
	const { source, fallbackValue } = item;

	if (!source) return <></>;

	function getDisplayText() {
		let text = source ? dataTypeSourceOptions[source.type] : fallbackValue;
		if (source?.type === 'Internal') {
			const timestampText = source.timeStamp ? moment(source.timeStamp).format('DD MMM YYYY') : '';
			text = `${text}: ${timestampText}`
		}
		return text;
	}
	const icon = source ? dataTypeSourceIcons[source.type].icon : dataTypeSourceIcons['Unavailable'].icon
	
	// E.g., source-live, source-internal, source-unavailable
	const iconClassName = source ? `source-${source.type.toLowerCase()}` : '';

	return (

		<div className="entity-item-section">
			<div className={`content ${iconClassName}`}>
				<div className={`icon icon-${icon} icon-inline icon-only`} />
				<span className="text">{getDisplayText()}</span>
			</div>
		</div>
	)
}